import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';

/**
 * Alerts are urgent interruptions, requiring acknowledgement, that inform the user about a situation.
 */
 class showAlert extends Component {
   constructor(props) {
       super(props);
       this.state = {
         open: false,
       };
    }


  handleOpen = () => {
    this.setState({open: true});
  };


  render() {

    const {open, close, message, delteEntry} = this.props;
    const actions = [
      <FlatButton
        label="Cancelar"
        primary={true}
        onClick={close}
      />,
      <FlatButton
        label="Eliminar"
        primary={true}
        onClick={delteEntry}
      />,
    ];

    return (
      <div>
        <Dialog
          actions={actions}
          modal={false}
          open={open}
          onRequestClose={close}
        >
          {message}
        </Dialog>
      </div>
    );
  }
}

export default showAlert;



// WEBPACK FOOTER //
// ./components/data-containers/showAlert.js